import React from 'react';
import PropTypes from 'prop-types';
import ModalTrigger from '../../common/ModalTrigger';
import Finish from '../Finish';
import { analyticsTrack } from '../../../analyticsUtils';

const questionHeader = [
  { header: 'Start Here', text: '' },
  { header: 'About', text: 'Clora sends you projects that align with your level of experience' },
  { header: 'Past Experiences', text: 'Your past experience is one of the most important criteria that employers review when they evaluate candidates.' },
  { header: 'Education', text: 'Clora sends you projects that align with the degrees you hold' },
  { header: 'Functional Areas', text: 'Matching functional areas is one of the primary ways we refine project suggestions for you' },
  { header: 'Therapeutic Areas', text: 'We improve project suggestions by leveraging therapeutic areas' },
  { header: 'Industries and Product Technologies', text: "Clora's technology will leverage industries, phases, and product types to further enrich your project suggestions" },
  { header: 'Preferences', text: "Clora's technology will leverage industries, phases, and product types to further enrich your project suggestions" },
];

function FinishLater({
  userId,
  onboardType,
  name,
  step,
  claimInfoUrl,
  resourceLink,
  csrfToken,
}) {
  const onClick = () => {
    analyticsTrack('Clicking on Finish Later', {
      location: 'Onboarding Flow',
      step: questionHeader[step].header,
      userId,
    });
  };

  const onClose = () => {
    analyticsTrack('Closing Finish Later', {
      location: 'Onboarding Flow',
      step: questionHeader[step].header,
      userId,
    });
  };

  return (
    <ModalTrigger
      triggerText="FINISH LATER"
      buttonStyles="primary text-decoration-none"
      idKey="claim-your-info-skip-profile-setting-link"
      showFooter={false}
      triggerType="link"
      onClick={() => onClick()}
      onCloseCallback={() => onClose()}
      dialogClassName="modal-90w"
      cloneContent

    >
      <Finish
        userId={userId}
        claimInfoUrl={claimInfoUrl}
        csrfToken={csrfToken}
        resourceLink={resourceLink}
        name={name}
        step={questionHeader[step].header}
        onboardType={onboardType}
        finish={false}
      />
    </ModalTrigger>
  );
}

FinishLater.propTypes = {
  onboardType: PropTypes.string.isRequired,
  name: PropTypes.string.isRequired,
  step: PropTypes.number.isRequired,
  resourceLink: PropTypes.string.isRequired,
  csrfToken: PropTypes.string.isRequired,
  userId: PropTypes.string.isRequired,
  claimInfoUrl: PropTypes.string.isRequired,
};

export default FinishLater;
